import img1_copy from '../assets/placements/copy/skyford_placement_1.jpg';
import img1 from '../assets/placements/skyford_placement_1.webp';
import img2_copy from '../assets/placements/copy/skyford_placement_2.jpg';
import img2 from '../assets/placements/skyford_placement_2.webp';
import img3_copy from '../assets/placements/copy/skyford_placement_3.jpg';
import img3 from '../assets/placements/skyford_placement_3.webp';
import img4_copy from '../assets/placements/copy/skyford_placement_4.jpg';
import img4 from '../assets/placements/skyford_placement_4.webp';
import img5_copy from '../assets/placements/copy/skyford_placement_5.jpg';
import img5 from '../assets/placements/skyford_placement_5.webp';
import img6_copy from '../assets/placements/copy/skyford_placement_6.jpg';
import img6 from '../assets/placements/skyford_placement_6.webp';
import img7_copy from '../assets/placements/copy/skyford_placement_7.jpg';
import img7 from '../assets/placements/skyford_placement_7.webp';
import img8_copy from '../assets/placements/copy/skyford_placement_8.jpg';
import img8 from '../assets/placements/skyford_placement_8.webp';
import img9_copy from '../assets/placements/copy/skyford_placement_9.jpg';
import img9 from '../assets/placements/skyford_placement_9.webp';
import img10_copy from '../assets/placements/copy/skyford_placement_10.jpg';
import img10 from '../assets/placements/skyford_placement_10.webp';
import img11_copy from '../assets/placements/copy/skyford_placement_11.jpg';
import img11 from '../assets/placements/skyford_placement_11.webp';
import img12_copy from '../assets/placements/copy/skyford_placement_12.jpg';
import img12 from '../assets/placements/skyford_placement_12.webp';
import img13_copy from '../assets/placements/copy/skyford_placement_13.jpg';
import img13 from '../assets/placements/skyford_placement_13.webp';
import img14_copy from '../assets/placements/copy/skyford_placement_14.jpg';
import img14 from '../assets/placements/skyford_placement_14.webp';
import img15_copy from '../assets/placements/copy/skyford_placement_15.jpg';
import img15 from '../assets/placements/skyford_placement_15.webp';
import img16_copy from '../assets/placements/copy/skyford_placement_16.jpg';
import img16 from '../assets/placements/skyford_placement_16.webp';
import img17_copy from '../assets/placements/copy/skyford_placement_17.jpg';
import img17 from '../assets/placements/skyford_placement_17.webp';
import img18_copy from '../assets/placements/copy/skyford_placement_18.jpg';
import img18 from '../assets/placements/skyford_placement_18.webp';
import img19_copy from '../assets/placements/copy/skyford_placement_19.jpg';
import img19 from '../assets/placements/skyford_placement_19.webp';
import img20_copy from '../assets/placements/copy/skyford_placement_20.jpg';
import img20 from '../assets/placements/skyford_placement_20.webp';
import img21_copy from '../assets/placements/copy/skyford_placement_21.jpg';
import img21 from '../assets/placements/skyford_placement_21.webp';
import img22_copy from '../assets/placements/copy/skyford_placement_22.jpg';
import img22 from '../assets/placements/skyford_placement_22.webp';
import img23_copy from '../assets/placements/copy/skyford_placement_23.jpg';
import img23 from '../assets/placements/skyford_placement_23.webp';
import img24_copy from '../assets/placements/copy/skyford_placement_24.jpg';
import img24 from '../assets/placements/skyford_placement_24.webp';
import img25_copy from '../assets/placements/copy/skyford_placement_25.jpg';
import img25 from '../assets/placements/skyford_placement_25.webp';
import img26_copy from '../assets/placements/copy/skyford_placement_26.jpg';
import img26 from '../assets/placements/skyford_placement_26.webp';
import img27_copy from '../assets/placements/copy/skyford_placement_27.jpg';
import img27 from '../assets/placements/skyford_placement_27.webp';
import img28_copy from '../assets/placements/copy/skyford_placement_28.jpg';
import img28 from '../assets/placements/skyford_placement_28.webp';
import img29_copy from '../assets/placements/copy/skyford_placement_29.jpg';
import img29 from '../assets/placements/skyford_placement_29.webp';
import img30_copy from '../assets/placements/copy/skyford_placement_30.jpg';
import img30 from '../assets/placements/skyford_placement_30.webp';
import img31_copy from '../assets/placements/copy/skyford_placement_31.jpg';
import img31 from '../assets/placements/skyford_placement_31.webp';
import img32_copy from '../assets/placements/copy/skyford_placement_32.jpg';
import img32 from '../assets/placements/skyford_placement_32.webp';

//=============================== V2 IMAGE START ===============================
import v2Img1 from '../assets/placements/placements-v2/p-1.jpeg';
import v2Img2 from '../assets/placements/placements-v2/p-2.jpeg';
import v2Img3 from '../assets/placements/placements-v2/p-3.jpeg';
import v2Img4 from '../assets/placements/placements-v2/p-4.jpeg';
import v2Img5 from '../assets/placements/placements-v2/p-5.jpeg';
import v2Img6 from '../assets/placements/placements-v2/p-6.jpeg';
import v2Img7 from '../assets/placements/placements-v2/p-7.jpeg';
import v2Img8 from '../assets/placements/placements-v2/p-8.jpeg';
import v2Img9 from '../assets/placements/placements-v2/p-9.jpeg';
import v2Img10 from '../assets/placements/placements-v2/p-10.jpeg';
import v2Img11 from '../assets/placements/placements-v2/p-11.jpeg';
import v2Img12 from '../assets/placements/placements-v2/p-12.jpeg';
import v2Img13 from '../assets/placements/placements-v2/p-13.jpeg';
import v2Img14 from '../assets/placements/placements-v2/p-14.jpeg';
import v2Img15 from '../assets/placements/placements-v2/p-15.jpeg';
import v2Img16 from '../assets/placements/placements-v2/p-16.jpeg';
import v2Img17 from '../assets/placements/placements-v2/p-17.jpeg';
import v2Img18 from '../assets/placements/placements-v2/p-18.jpeg';
import v2Img19 from '../assets/placements/placements-v2/p-20.jpeg';
import v2Img20 from '../assets/placements/placements-v2/p-21.jpeg';
import v2Img21 from '../assets/placements/placements-v2/p-22.jpeg';
import v2Img22 from '../assets/placements/placements-v2/p-23.jpeg';
import v2Img23 from '../assets/placements/placements-v2/p-24.jpeg';
import v2Img24 from '../assets/placements/placements-v2/p-25.jpeg';
import v2Img25 from '../assets/placements/placements-v2/p-26.jpeg';
import v2Img26 from '../assets/placements/placements-v2/p-27.jpeg';
import v2Img27 from '../assets/placements/placements-v2/p-28.jpeg';
import v2Img28 from '../assets/placements/placements-v2/p-29.jpeg';
import v2Img29 from '../assets/placements/placements-v2/p-30.jpeg';
import v2Img30 from '../assets/placements/placements-v2/p-31.jpeg';
import v2Img31 from '../assets/placements/placements-v2/p-32.jpeg';
import v2Img32 from '../assets/placements/placements-v2/p-33.jpeg';
import v2Img33 from '../assets/placements/placements-v2/p-34.jpeg';
import v2Img34 from '../assets/placements/placements-v2/p-35.jpeg';
import v2Img35 from '../assets/placements/placements-v2/p-36.jpeg';
import v2Img36 from '../assets/placements/placements-v2/p-37.jpeg';
import v2Img37 from '../assets/placements/placements-v2/p-38.jpeg';
import v2Img38 from '../assets/placements/placements-v2/p-39.jpeg';
import v2Img39 from '../assets/placements/placements-v2/p-40.jpeg';
import v2Img40 from '../assets/placements/placements-v2/p-41.jpeg';
import v2Img41 from '../assets/placements/placements-v2/p-42.jpeg';
import v2Img42 from '../assets/placements/placements-v2/p-43.jpeg';
import v2Img43 from '../assets/placements/placements-v2/p-44.jpeg';
import v2Img44 from '../assets/placements/placements-v2/p-45.jpeg';
import v2Img45 from '../assets/placements/placements-v2/p-46.jpeg';
import v2Img46 from '../assets/placements/placements-v2/p-47.jpeg';
import v2Img47 from '../assets/placements/placements-v2/p-48.jpeg';
import v2Img48 from '../assets/placements/placements-v2/p-49.jpeg';
import v2Img49 from '../assets/placements/placements-v2/p-50.jpeg';
import v2Img50 from '../assets/placements/placements-v2/p-51.jpeg';
import v2Img51 from '../assets/placements/placements-v2/p-52.jpeg';
import v2Img52 from '../assets/placements/placements-v2/p-53.jpeg';
import v2Img53 from '../assets/placements/placements-v2/p-54.jpeg';
import v2Img54 from '../assets/placements/placements-v2/p-55.jpeg';
import v2Img55 from '../assets/placements/placements-v2/p-56.jpeg';
import v2Img56 from '../assets/placements/placements-v2/p-57.jpeg';
import v2Img57 from '../assets/placements/placements-v2/p-58.jpeg';
import v2Img58 from '../assets/placements/placements-v2/p-59.jpeg';
import v2Img59 from '../assets/placements/placements-v2/p-60.jpeg';
import v2Img60 from '../assets/placements/placements-v2/p-61.jpeg';
import v2Img61 from '../assets/placements/placements-v2/p-62.jpeg';
import v2Img62 from '../assets/placements/placements-v2/p-63.jpeg';
import v2Img63 from '../assets/placements/placements-v2/p-64.jpeg';
import v2Img64 from '../assets/placements/placements-v2/p-65.jpeg';
import v2Img65 from '../assets/placements/placements-v2/p-66.jpeg';
import v2Img66 from '../assets/placements/placements-v2/p-67.jpeg';
import v2Img67 from '../assets/placements/placements-v2/p-68.jpeg';
import v2Img68 from '../assets/placements/placements-v2/p-69.jpeg';



//------------------------ V2 IMAGE COPY 

import v2Img1Copy from '../assets/placements/placements-v2/v2-copy/p-1 copy.png';
import v2Img2Copy from '../assets/placements/placements-v2/v2-copy/p-2 copy.png';
import v2Img3Copy from '../assets/placements/placements-v2/v2-copy/p-3.jpg';
import v2Img4Copy from '../assets/placements/placements-v2/v2-copy/p-4.jpg';
import v2Img5Copy from '../assets/placements/placements-v2/v2-copy/p-5.jpg';
import v2Img6Copy from '../assets/placements/placements-v2/v2-copy/p-6.jpg';
import v2Img7Copy from '../assets/placements/placements-v2/v2-copy/p-7.jpg';
import v2Img8Copy from '../assets/placements/placements-v2/v2-copy/p-8.jpg';
import v2Img9Copy from '../assets/placements/placements-v2/v2-copy/p-9.jpg';
import v2Img10Copy from '../assets/placements/placements-v2/v2-copy/p-10.jpg';
import v2Img11Copy from '../assets/placements/placements-v2/v2-copy/p-11.jpg';
import v2Img12Copy from '../assets/placements/placements-v2/v2-copy/p-12.jpg';
import v2Img13Copy from '../assets/placements/placements-v2/v2-copy/p-13.jpg';
import v2Img14Copy from '../assets/placements/placements-v2/v2-copy/p-14.jpg';
import v2Img15Copy from "../assets/placements/placements-v2/v2-copy/p-15.jpg";
import v2Img16Copy from "../assets/placements/placements-v2/v2-copy/p-16.jpg";
import v2Img17Copy from "../assets/placements/placements-v2/v2-copy/p-17.jpg";
import v2Img18Copy from "../assets/placements/placements-v2/v2-copy/p-18.jpg";
import v2Img19Copy from "../assets/placements/placements-v2/v2-copy/p-20.jpg";
import v2Img20Copy from "../assets/placements/placements-v2/v2-copy/p-21.jpg";
import v2Img21Copy from "../assets/placements/placements-v2/v2-copy/p-22.jpg";
import v2Img22Copy from "../assets/placements/placements-v2/v2-copy/p-23.jpg";
import v2Img23Copy from "../assets/placements/placements-v2/v2-copy/p-24.jpg";
import v2Img24Copy from "../assets/placements/placements-v2/v2-copy/p-25.jpg";
import v2Img25Copy from "../assets/placements/placements-v2/v2-copy/p-26.jpg";
import v2Img26Copy from "../assets/placements/placements-v2/v2-copy/p-27.jpg";
import v2Img27Copy from "../assets/placements/placements-v2/v2-copy/p-28.jpg";
import v2Img28Copy from "../assets/placements/placements-v2/v2-copy/p-29.jpg";
import v2Img29Copy from "../assets/placements/placements-v2/v2-copy/p-30.jpg";

import v2Img30Copy from "../assets/placements/placements-v2/v2-copy/p-31.jpg";
import v2Img31Copy from "../assets/placements/placements-v2/v2-copy/p-32.jpg";
import v2Img32Copy from "../assets/placements/placements-v2/v2-copy/p-33.jpg";
import v2Img33Copy from "../assets/placements/placements-v2/v2-copy/p-34.jpg";
import v2Img34Copy from "../assets/placements/placements-v2/v2-copy/p-35.jpg";
import v2Img35Copy from "../assets/placements/placements-v2/v2-copy/p-36.jpg";
import v2Img36Copy from "../assets/placements/placements-v2/v2-copy/p-37.jpg";
import v2Img37Copy from "../assets/placements/placements-v2/v2-copy/p-38.jpg";
import v2Img38Copy from "../assets/placements/placements-v2/v2-copy/p-39.jpg";
import v2Img39Copy from "../assets/placements/placements-v2/v2-copy/p-40.jpg";
import v2Img40Copy from "../assets/placements/placements-v2/v2-copy/p-41.jpg";
import v2Img41Copy from "../assets/placements/placements-v2/v2-copy/p-42.jpg";
import v2Img42Copy from "../assets/placements/placements-v2/v2-copy/p-43.jpg";
import v2Img43Copy from "../assets/placements/placements-v2/v2-copy/p-44.jpg";
import v2Img44Copy from "../assets/placements/placements-v2/v2-copy/p-45.jpg";
import v2Img45Copy from "../assets/placements/placements-v2/v2-copy/p-46.jpg";
import v2Img46Copy from "../assets/placements/placements-v2/v2-copy/p-47.jpg";
import v2Img47Copy from "../assets/placements/placements-v2/v2-copy/p-48.jpg";
import v2Img48Copy from "../assets/placements/placements-v2/v2-copy/p-49.jpg";
import v2Img49Copy from "../assets/placements/placements-v2/v2-copy/p-50.jpg";
import v2Img50Copy from "../assets/placements/placements-v2/v2-copy/p-51.jpg";
import v2Img51Copy from "../assets/placements/placements-v2/v2-copy/p-52.jpg";
import v2Img52Copy from "../assets/placements/placements-v2/v2-copy/p-53.jpg";
import v2Img53Copy from "../assets/placements/placements-v2/v2-copy/p-54.jpg";
import v2Img54Copy from "../assets/placements/placements-v2/v2-copy/p-55.jpg";
import v2Img55Copy from "../assets/placements/placements-v2/v2-copy/p-56.jpg";
import v2Img56Copy from "../assets/placements/placements-v2/v2-copy/p-57.jpg";
import v2Img57Copy from "../assets/placements/placements-v2/v2-copy/p-58.jpg";
import v2Img58Copy from "../assets/placements/placements-v2/v2-copy/p-59.jpg";
import v2Img59Copy from "../assets/placements/placements-v2/v2-copy/p-60.jpg";
import v2Img60Copy from "../assets/placements/placements-v2/v2-copy/p-61.jpg";
import v2Img61Copy from "../assets/placements/placements-v2/v2-copy/p-62.jpg";
import v2Img62Copy from "../assets/placements/placements-v2/v2-copy/p-63.jpg";
import v2Img63Copy from "../assets/placements/placements-v2/v2-copy/p-64.jpg";
import v2Img64Copy from "../assets/placements/placements-v2/v2-copy/p-65.jpg";
import v2Img65Copy from "../assets/placements/placements-v2/v2-copy/p-66.jpg";
import v2Img66Copy from "../assets/placements/placements-v2/v2-copy/p-67.jpg";
import v2Img67Copy from "../assets/placements/placements-v2/v2-copy/p-68.jpg";
import v2Img68Copy from "../assets/placements/placements-v2/v2-copy/p-69.jpg";

//=============================== V2 IMAGE END ===============================



const placements = [
  //========================= V2 IMAGES =========================
  { id: 33, company: "SET_COMPANY", image: v2Img1, copyImage: v2Img1Copy /* location: "SET_LOCATION" */ },
  { id: 34, company: "SET_COMPANY", image: v2Img2, copyImage: v2Img2Copy /* location: "SET_LOCATION" */ },
  { id: 35, company: "SET_COMPANY", image: v2Img3, copyImage: v2Img3Copy /* location: "SET_LOCATION" */ },
  { id: 36, company: "SET_COMPANY", image: v2Img4, copyImage: v2Img4Copy /* location: "SET_LOCATION" */ },
  { id: 37, company: "SET_COMPANY", image: v2Img5, copyImage: v2Img5Copy /* location: "SET_LOCATION" */ },
  { id: 38, company: "SET_COMPANY", image: v2Img6, copyImage: v2Img6Copy /* location: "SET_LOCATION" */ },
  { id: 39, company: "SET_COMPANY", image: v2Img7, copyImage: v2Img7Copy /* location: "SET_LOCATION" */ },
  { id: 40, company: "SET_COMPANY", image: v2Img8, copyImage: v2Img8Copy /* location: "SET_LOCATION" */ },
  { id: 41, company: "SET_COMPANY", image: v2Img9, copyImage: v2Img9Copy /* location: "SET_LOCATION" */ },
  { id: 42, company: "SET_COMPANY", image: v2Img10, copyImage: v2Img10Copy /* location: "SET_LOCATION" */ },
  { id: 43, company: "SET_COMPANY", image: v2Img11, copyImage: v2Img11Copy /* location: "SET_LOCATION" */ },
  { id: 44, company: "SET_COMPANY", image: v2Img12, copyImage: v2Img12Copy /* location: "SET_LOCATION" */ },
  { id: 45, company: "SET_COMPANY", image: v2Img13, copyImage: v2Img13Copy /* location: "SET_LOCATION" */ },
  { id: 46, company: "SET_COMPANY", image: v2Img14, copyImage: v2Img14Copy /* location: "SET_LOCATION" */ },
  { id: 47, company: "SET_COMPANY", image: v2Img15, copyImage: v2Img15Copy /* location: "SET_LOCATION" */ },
  { id: 48, company: "SET_COMPANY", image: v2Img16, copyImage: v2Img16Copy /* location: "SET_LOCATION" */ },
  { id: 49, company: "SET_COMPANY", image: v2Img17, copyImage: v2Img17Copy /* location: "SET_LOCATION" */ },
  { id: 50, company: "SET_COMPANY", image: v2Img18, copyImage: v2Img18Copy /* location: "SET_LOCATION" */ },
  { id: 51, company: "SET_COMPANY", image: v2Img19, copyImage: v2Img19Copy /* location: "SET_LOCATION" */ },
  { id: 52, company: "SET_COMPANY", image: v2Img20, copyImage: v2Img20Copy /* location: "SET_LOCATION" */ },
  { id: 53, company: "SET_COMPANY", image: v2Img21, copyImage: v2Img21Copy /* location: "SET_LOCATION" */ },
  { id: 54, company: "SET_COMPANY", image: v2Img22, copyImage: v2Img22Copy /* location: "SET_LOCATION" */ },
  { id: 55, company: "SET_COMPANY", image: v2Img23, copyImage: v2Img23Copy /* location: "SET_LOCATION" */ },
  { id: 56, company: "SET_COMPANY", image: v2Img24, copyImage: v2Img24Copy /* location: "SET_LOCATION" */ },
  { id: 57, company: "SET_COMPANY", image: v2Img25, copyImage: v2Img25Copy /* location: "SET_LOCATION" */ },
  { id: 58, company: "SET_COMPANY", image: v2Img26, copyImage: v2Img26Copy /* location: "SET_LOCATION" */ },
  { id: 59, company: "SET_COMPANY", image: v2Img27, copyImage: v2Img27Copy /* location: "SET_LOCATION" */ },
  { id: 60, company: "SET_COMPANY", image: v2Img28, copyImage: v2Img28Copy /* location: "SET_LOCATION" */ },
  { id: 61, company: "SET_COMPANY", image: v2Img29, copyImage: v2Img29Copy /* location: "SET_LOCATION" */ },
  { id: 62, company: "SET_COMPANY", image: v2Img30, copyImage: v2Img30Copy /* location: "SET_LOCATION" */ },
  { id: 63, company: "SET_COMPANY", image: v2Img31, copyImage: v2Img31Copy /* location: "SET_LOCATION" */ },
  { id: 64, company: "SET_COMPANY", image: v2Img32, copyImage: v2Img32Copy /* location: "SET_LOCATION" */ },
  { id: 65, company: "SET_COMPANY", image: v2Img33, copyImage: v2Img33Copy /* location: "SET_LOCATION" */ },
  { id: 66, company: "SET_COMPANY", image: v2Img34, copyImage: v2Img34Copy /* location: "SET_LOCATION" */ },
  { id: 67, company: "SET_COMPANY", image: v2Img35, copyImage: v2Img35Copy /* location: "SET_LOCATION" */ },
  { id: 68, company: "SET_COMPANY", image: v2Img36, copyImage: v2Img36Copy /* location: "SET_LOCATION" */ },
  { id: 69, company: "SET_COMPANY", image: v2Img37, copyImage: v2Img37Copy /* location: "SET_LOCATION" */ },
  { id: 70, company: "SET_COMPANY", image: v2Img38, copyImage: v2Img38Copy /* location: "SET_LOCATION" */ },
  { id: 71, company: "SET_COMPANY", image: v2Img39, copyImage: v2Img39Copy /* location: "SET_LOCATION" */ },
  { id: 72, company: "SET_COMPANY", image: v2Img40, copyImage: v2Img40Copy /* location: "SET_LOCATION" */ },
  { id: 73, company: "SET_COMPANY", image: v2Img41, copyImage: v2Img41Copy /* location: "SET_LOCATION" */ },
  { id: 74, company: "SET_COMPANY", image: v2Img42, copyImage: v2Img42Copy /* location: "SET_LOCATION" */ },
  { id: 75, company: "SET_COMPANY", image: v2Img43, copyImage: v2Img43Copy /* location: "SET_LOCATION" */ },
  { id: 76, company: "SET_COMPANY", image: v2Img44, copyImage: v2Img44Copy /* location: "SET_LOCATION" */ },
  { id: 77, company: "SET_COMPANY", image: v2Img45, copyImage: v2Img45Copy /* location: "SET_LOCATION" */ },
  { id: 78, company: "SET_COMPANY", image: v2Img46, copyImage: v2Img46Copy /* location: "SET_LOCATION" */ },
  { id: 79, company: "SET_COMPANY", image: v2Img47, copyImage: v2Img47Copy /* location: "SET_LOCATION" */ },
  { id: 80, company: "SET_COMPANY", image: v2Img48, copyImage: v2Img48Copy /* location: "SET_LOCATION" */ },
  { id: 81, company: "SET_COMPANY", image: v2Img49, copyImage: v2Img49Copy /* location: "SET_LOCATION" */ },
  { id: 82, company: "SET_COMPANY", image: v2Img50, copyImage: v2Img50Copy /* location: "SET_LOCATION" */ },
  { id: 83, company: "SET_COMPANY", image: v2Img51, copyImage: v2Img51Copy /* location: "SET_LOCATION" */ },
  { id: 84, company: "SET_COMPANY", image: v2Img52, copyImage: v2Img52Copy /* location: "SET_LOCATION" */ },
  { id: 85, company: "SET_COMPANY", image: v2Img53, copyImage: v2Img53Copy /* location: "SET_LOCATION" */ },
  { id: 86, company: "SET_COMPANY", image: v2Img54, copyImage: v2Img54Copy /* location: "SET_LOCATION" */ },
  { id: 87, company: "SET_COMPANY", image: v2Img55, copyImage: v2Img55Copy /* location: "SET_LOCATION" */ },
  { id: 88, company: "SET_COMPANY", image: v2Img56, copyImage: v2Img56Copy /* location: "SET_LOCATION" */ },
  { id: 89, company: "SET_COMPANY", image: v2Img57, copyImage: v2Img57Copy /* location: "SET_LOCATION" */ },
  { id: 90, company: "SET_COMPANY", image: v2Img58, copyImage: v2Img58Copy /* location: "SET_LOCATION" */ },
  { id: 91, company: "SET_COMPANY", image: v2Img59, copyImage: v2Img59Copy /* location: "SET_LOCATION" */ },
  { id: 92, company: "SET_COMPANY", image: v2Img60, copyImage: v2Img60Copy /* location: "SET_LOCATION" */ },
  { id: 93, company: "SET_COMPANY", image: v2Img61, copyImage: v2Img61Copy /* location: "SET_LOCATION" */ },
  { id: 94, company: "SET_COMPANY", image: v2Img62, copyImage: v2Img62Copy /* location: "SET_LOCATION" */ },
  { id: 95, company: "SET_COMPANY", image: v2Img63, copyImage: v2Img63Copy /* location: "SET_LOCATION" */ },
  { id: 96, company: "SET_COMPANY", image: v2Img64, copyImage: v2Img64Copy /* location: "SET_LOCATION" */ },
  { id: 97, company: "SET_COMPANY", image: v2Img65, copyImage: v2Img65Copy /* location: "SET_LOCATION" */ },
  { id: 98, company: "SET_COMPANY", image: v2Img66, copyImage: v2Img66Copy /* location: "SET_LOCATION" */ },
  { id: 99, company: "SET_COMPANY", image: v2Img67, copyImage: v2Img67Copy /* location: "SET_LOCATION" */ },
  { id: 100, company: "SET_COMPANY", image: v2Img68, copyImage: v2Img68Copy /* location: "SET_LOCATION" */ },
  //========================= V2 IMAGES =========================



    { id: 1, company: "Emirates", image: img1, copyImage: img1_copy, location: "Dubai, UAE" },
    { id: 2, company: "Air India", image: img2, copyImage: img2_copy, location: "Mumbai, India" },
    { id: 3, company: "Qatar Airways", image: img3, copyImage: img3_copy, location: "Doha, Qatar" },
    { id: 4, company: "Etihad Airways", image: img4, copyImage: img4_copy, location: "Abu Dhabi, UAE" },
    { id: 5, company: "Singapore Airlines", image: img5, copyImage: img5_copy, location: "Singapore" },
    { id: 6, company: "Lufthansa", image: img6, copyImage: img6_copy, location: "Frankfurt, Germany" },
    { id: 7, company: "British Airways", image: img7, copyImage: img7_copy, location: "London, UK" },
    { id: 8, company: "Air France", image: img8, copyImage: img8_copy, location: "Paris, France" },
    { id: 9, company: "Emirates", image: img9, copyImage: img9_copy, location: "Dubai, UAE" },
    { id: 10, company: "Air India", image: img10, copyImage: img10_copy, location: "Mumbai, India" },
    { id: 11, company: "Qatar Airways", image: img11, copyImage: img11_copy, location: "Doha, Qatar" },
    { id: 12, company: "Etihad Airways", image: img12, copyImage: img12_copy, location: "Abu Dhabi, UAE" },
    { id: 13, company: "Singapore Airlines", image: img13, copyImage: img13_copy, location: "Singapore" },
    { id: 14, company: "Lufthansa", image: img14, copyImage: img14_copy, location: "Frankfurt, Germany" },
    { id: 15, company: "British Airways", image: img15, copyImage: img15_copy, location: "London, UK" },
    { id: 16, company: "Air France", image: img16, copyImage: img16_copy, location: "Paris, France" },
    { id: 17, company: "Emirates", image: img17, copyImage: img17_copy, location: "Dubai, UAE" },
    { id: 18, company: "Air India", image: img18, copyImage: img18_copy, location: "Mumbai, India" },
    { id: 19, company: "Qatar Airways", image: img19, copyImage: img19_copy, location: "Doha, Qatar" },
    { id: 20, company: "Etihad Airways", image: img20, copyImage: img20_copy, location: "Abu Dhabi, UAE" },
    { id: 21, company: "Singapore Airlines", image: img21, copyImage: img21_copy, location: "Singapore" },
    { id: 22, company: "Lufthansa", image: img22, copyImage: img22_copy, location: "Frankfurt, Germany" },
    { id: 23, company: "British Airways", image: img23, copyImage: img23_copy, location: "London, UK" },
    { id: 24, company: "Air France", image: img24, copyImage: img24_copy, location: "Paris, France" },
    { id: 25, company: "Emirates", image: img25, copyImage: img25_copy, location: "Dubai, UAE" },
    { id: 26, company: "Air India", image: img26, copyImage: img26_copy, location: "Mumbai, India" },
    { id: 27, company: "Qatar Airways", image: img27, copyImage: img27_copy, location: "Doha, Qatar" },
    { id: 28, company: "Etihad Airways", image: img28, copyImage: img28_copy, location: "Abu Dhabi, UAE" },
    { id: 29, company: "Singapore Airlines", image: img29, copyImage: img29_copy, location: "Singapore" },
    { id: 30, company: "Lufthansa", image: img30, copyImage: img30_copy, location: "Frankfurt, Germany" },
    { id: 31, company: "British Airways", image: img31, copyImage: img31_copy, location: "London, UK" },
    { id: 32, company: "Air France", image: img32, copyImage: img32_copy, location: "Paris, France" },
  ];

  export default placements;